/**
 * @generated SignedSource<<7e3802ebe1307519b185e2189d28f4b1>>
 * @relayHash b2e2720cbf3a1adc8b0afd4eecdd3543
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b9c9319ef635e7f180fb5e4a95b825a402925516e37068c17e623eb6f000346d

import type { ConcreteRequest, Query } from 'relay-runtime';
export type SpaceIdentifiersQuery$variables = {
  spaceKey?: string | null | undefined;
};
export type SpaceIdentifiersQuery$data = {
  readonly space: {
    readonly id: string | null | undefined;
    readonly key: string | null | undefined;
  } | null | undefined;
};
export type SpaceIdentifiersQuery = {
  response: SpaceIdentifiersQuery$data;
  variables: SpaceIdentifiersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "key"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "SpaceIdentifiersQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SpaceIdentifiersQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b2e2720cbf3a1adc8b0afd4eecdd3543",
    "id": "b9c9319ef635e7f180fb5e4a95b825a402925516e37068c17e623eb6f000346d",
    "metadata": {},
    "name": "SpaceIdentifiersQuery",
    "operationKind": "query",
    "text": "query SpaceIdentifiersQuery($spaceKey:String){space(key:$spaceKey){id,key}}"
  }
};
})();

(node as any).hash = "5dbfb373d09461f4a31f7a649d4a515c";

export default node;
